import React from 'react'

import { IHomeType, IPageType } from '@/types'

export const PledgeSection: React.FC<IPageType<IHomeType>> = ({ template }) => {
  return (
    <section className="complete_clean_pledge padding-vertical--small blue-color">
      <div className="row align-middle">
        <div className="column small-6 medium-3 large-2 mobile_margin">
          <img
            title=""
            alt="alamo completeclean pledge enus"
            src="/assets/img/alamo-completeclean-pledge-enus.png"
          />
        </div>
        <br />
        <div className="column small-12 medium-9 media_text">
          <br />
          {!!template.section_1_title_1 && (
            <h2>{template.section_1_title_1}</h2>
          )}
          <br />
          {!!template.section_1_description_1 && (
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: template.section_1_description_1,
              }}
            />
          )}
          {!!template.section_1_title_2 && (
            <>
              <br />
              <br />
            </>
          )}
          {!!template.section_1_title_2 && (
            <h2>{template.section_1_title_2}</h2>
          )}
          {!!template.section_1_description_2 && (
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: template.section_1_description_2,
              }}
            />
          )}
        </div>
      </div>
    </section>
  )
}
